import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import OutbOrdReservedStockReportActions from '../../Stores/OutbOrdReservedStockReport/Actions';

const { Panel } = Collapse;

class OutbOrdReservedStockReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initOutbOrdReservedStock } = this.props;

    if (curSiteFlowId > 0) {
      initOutbOrdReservedStock();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initOutbOrdReservedStock } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initOutbOrdReservedStock();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'outbound_order_reserved_stock_report' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

OutbOrdReservedStockReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initOutbOrdReservedStock: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

OutbOrdReservedStockReportScreen.defaultProps = {
  intl: {},
  match: {},

  initOutbOrdReservedStock: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initOutbOrdReservedStock: () =>
    dispatch(OutbOrdReservedStockReportActions.outbOrdReservedStockReportInitOutbOrdReservedStock())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(OutbOrdReservedStockReportScreen));
